import { createSelector } from "reselect";
import get from "src/lib/get";
import { getUser } from ".";

export const getReturnedOrders = createSelector(getUser, (user) => {
  return get(user, "returnedOrders.data", []);
});
